import React from "react";

export default function UserLockModal() {
  return <div>UserLockModal</div>;
}
